"use strict";
/*
 * Created on 5. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Request for updating exported flag on the release item.
 * @author Radek Beran
 */


var ExportedUpdateRequest =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ExportedUpdateRequest, _DomainObject_1$Domai);

  function ExportedUpdateRequest(
  /* public readonly priceZoneId: string, */
  exported) {
    var _this;

    _classCallCheck(this, ExportedUpdateRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedUpdateRequest).call(this));
    _this.exported = exported;
    return _this;
  }

  return ExportedUpdateRequest;
}(DomainObject_1.DomainObject);

exports.ExportedUpdateRequest = ExportedUpdateRequest;

ExportedUpdateRequest.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ExportedUpdateRequest.name);
  return {
    // priceZoneId: builder.str('priceZoneId'),
    exported: builder.bool('exported')
  };
}();